import React from "react";
import { Stack, Button, CircularProgress, Typography } from "@mui/material";

export default function Error({ error, loading, refetch }) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="calc(100vh - 72px)"
    >
      <Typography align="center" variant="subtitle1" color="error">
        {error}
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Button size="small" color="error" variant="outlined" onClick={refetch}>
          Refresh
        </Button>
      )}
    </Stack>
  );
}
